/* tslint:disable */
/* eslint-disable */
/**
 * Muisti API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ExhibitionPageEventPropertyType,
    ExhibitionPageEventPropertyTypeFromJSON,
    ExhibitionPageEventPropertyTypeFromJSONTyped,
    ExhibitionPageEventPropertyTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExhibitionPageEventProperty
 */
export interface ExhibitionPageEventProperty {
    /**
     * 
     * @type {string}
     * @memberof ExhibitionPageEventProperty
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ExhibitionPageEventProperty
     */
    value: string;
    /**
     * 
     * @type {ExhibitionPageEventPropertyType}
     * @memberof ExhibitionPageEventProperty
     */
    type: ExhibitionPageEventPropertyType;
}

export function ExhibitionPageEventPropertyFromJSON(json: any): ExhibitionPageEventProperty {
    return ExhibitionPageEventPropertyFromJSONTyped(json, false);
}

export function ExhibitionPageEventPropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExhibitionPageEventProperty {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
        'type': ExhibitionPageEventPropertyTypeFromJSON(json['type']),
    };
}

export function ExhibitionPageEventPropertyToJSON(value?: ExhibitionPageEventProperty | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
        'type': ExhibitionPageEventPropertyTypeToJSON(value.type),
    };
}


